<template>
  <div class="PartsIE">
    <img
      class="PartsIE-img"
      src="https://formation.bienvenue.pro/images/Illustrations/eastwood-fatal-error.png"
      alt="not found"
    />
    <div class="PartsIE-error">{{ $t('part.ie.title') }}</div>
    <div class="PartsIE-msg">{{ $t('part.ie.msg') }}</div>
  </div>
</template>

<script>
'use strict'

export default {
  name: 'PartsIE'
}
</script>

<style lang="scss">
.PartsIE {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 80vh;
  &-img {
    width: 600px;
    height: auto;

    @media (max-width: $remove-logo) {
      display: none;
    }
  }
  &-error {
    padding: 0.75rem;
    font-size: 3rem;
    font-weight: 700;
  }
  &-msg {
    padding: 2rem;
    font-size: 2rem;
    text-align: center;
  }
}
</style>
